import {
  Enterprise,
  EnterpriseBusinessUnit,
  EnterpriseLocation,
} from 'models/Enterprises';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import { useCallback, useContext, useMemo, useState } from 'react';

export default function useEnterprise(enterpriseId: string) {
  const [enterprise, setEnterprise] = useState<Enterprise>();

  const {
    enterprise: usersEnterprise,
    enterpriseMember,
    updateCurrentUser,
  } = useContext(CurrentUserContext);

  const isMyEnteprise = useMemo(
    () => usersEnterprise?._id && enterpriseId === usersEnterprise?._id,
    [enterpriseId, usersEnterprise?._id],
  );

  const updateEnterprise = useCallback(
    (enterpise: Partial<Enterprise>) => {
      setEnterprise((prev) => {
        const updatedEnterprise = {
          ...prev,
          ...enterpise,
        };

        if (isMyEnteprise) {
          updateCurrentUser({
            enterpriseMember: {
              ...enterpriseMember,
              enterprise: {
                ...enterpriseMember?.enterprise,
                ...updatedEnterprise,
              },
            },
          });
        }

        return updatedEnterprise;
      });
    },
    [isMyEnteprise, enterpriseMember, updateCurrentUser],
  );

  const updateBusinessUnits = useCallback(
    (businessUnits: EnterpriseBusinessUnit[]) =>
      updateEnterprise({
        businessUnits,
        numberOfBusinessUnits: businessUnits.length,
      }),
    [updateEnterprise],
  );

  const updateMemberSeniorities = useCallback(
    (memberSeniorities: EnterpriseBusinessUnit[]) =>
      updateEnterprise({
        memberSeniorities,
      }),
    [updateEnterprise],
  );

  const updateMemberLocations = useCallback(
    (memberLocations: EnterpriseLocation[]) =>
      updateEnterprise({
        memberLocations,
      }),
    [updateEnterprise],
  );

  return {
    enterprise,
    isMyEnteprise,
    setEnterprise,
    updateEnterprise,
    updateBusinessUnits,
    updateMemberSeniorities,
    updateMemberLocations,
  };
}
